export type TagCommanderEnv = 'REC' | 'PROD';

export type TagCommanderEventFunction = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tc_elt: any,
  tc_id_event: string,
  tc_array_events: TagCommanderEventOptions,
) => void;

export enum TagCommanderClickType {
  Action = 'Action',
  Navigation = 'Navigation',
  Exit = 'exit',
}

export enum TagCommanderEventType {
  Click = 'CLICK',
  Impression = 'IMPRESSION',
  Page = 'PAGE',
}

export interface TagCommanderConfig {
  containerUrl: string;
  defaultVars: Partial<TagCommanderVars>;
}

export interface TagCommanderEvent {
  type: string;
  options: TagCommanderEventOptions;
}

export interface TagCommanderEventOptions {
  type_clic?: string;
  xt_clic?: string;
  clic?: string;
  page_xtpage?: string;
  id?: string;
  CAMPAGNE?: string;
}

export interface TagCommanderVars {
  site_environnement: string;
  site_parcours: string;
  url_log: string;
  url_slog: string;
  page_s1: string;
  page_s2: string;
  page_xtpage: string;
  page_chapitre: string;
  page_sous_chapitre: string;
  page_sous_sous_chapitre: string;
  page_page: string;
  page_template: string;
  user_id: string;
  user_id_AT: string;
  src: string;
  type: string;
  cat: string;
  num_dossier: string;
  offre_souscrite: string;
  maturite_projet: string;
  appetence_immo: string;
  type_page: string;
}

export interface WindowWithTagCommander extends Window {
  tc_events_26?: TagCommanderEventFunction;
}
